import { render, staticRenderFns } from "./KnDocsGalleryItem.vue?vue&type=template&id=65752bda&scoped=true"
import script from "./KnDocsGalleryItem.js?vue&type=script&lang=js&external"
export * from "./KnDocsGalleryItem.js?vue&type=script&lang=js&external"
import style0 from "./KnDocsGalleryItem.vue?vue&type=style&index=0&id=65752bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65752bda",
  null
  
)

export default component.exports